<template>
  <div class="care-breathing-section">
    <div
      class="care-breathing-section__bg"
      :style="{
        backgroundImage:
          isMobile
            ? 'url(/media/img/products/care/section-2-m.jpg)'
            : 'url(/media/img/products/care/section-2.jpg)',
      }"
    />
    <div class="care-breathing-section__main container">
      <div class="care-breathing-section__content">
        <img
          class="care-breathing-section__feature"
          src="/media/img/icons/care/icon_new_feature.png"
          alt="feature"
        >
        <div class="care-breathing-section__title">
          <img
            src="/media/img/icons/care/icon_breathing_detection.svg"
            alt="icon"
          >{{$t('care.sliderBreathing.title')}}
        </div>
        <p class="care-breathing-section__description">
          {{$t('care.sectionBreathing.desc')}}
        </p>
        <a
          class="care-breathing-section__link"
          href="https://support.lollipop.camera/hc/en-us/articles/10202143488793-How-does-the-Breathing-Detection-work-"
          target="_blank"
        >
          {{$t('care.sectionBreathing.linkText')}}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CareBreathingSection',
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile,
    }),
  },
};
</script>

<style lang="sass" scoped>
.container
  width: 100%;
  padding: 0 9vw;

  @media screen and (max-width: 1440px)
    padding: 0 3vw;

  @media screen and (max-width: 414px)
    padding: 0 30px;

  @media screen and (max-width: 375px)
    padding: 0 25px;

.care-breathing-section
  width: 100%
  height: 100%
  pointer-events: none
  opacity: 0
  transition: opacity 0.5s ease-in-out

  .page-care__scroll.active-0 &,
  .page-care__scroll.active-1 &
    transition: opacity 0.5s 0.5s ease-in-out
    pointer-events: auto
    opacity: 1

  &__bg
    position: absolute
    top: 0
    right: 0
    border-radius: 640px 0 0 640px
    width: 960px
    height: 100%
    background: #fff no-repeat center / cover
    pointer-events: none
    z-index: -1

    @media screen and (max-width: 1440px)
      width: 640px

    @media screen and (max-width: 1024px)
      width: 512px

    @media screen and (orientation: portrait), (max-width: 768px)
      display: none

  &__main
    width: 100%
    height: 100%
    display: flex
    justify-content: center
    flex-direction: column

    @media screen and (orientation: portrait), (max-width: 768px)
      justify-content: flex-end

  &__content
    max-width: 500px
    text-align: left
    z-index: 2

    @media screen and (max-width: 1440px)
      max-width: 360px

    @media screen and (max-width: 1024px)
      max-width: 300px

    @media screen and (orientation: portrait), (max-width: 768px)
      max-width: none
      width: 100%
      text-align: center
      transform: translate(0, 5%);
      transition: transform 0.5s ease-in-out
      flex: 1 1 auto
      margin-top: 480px;

      .page-care__scroll.active-0 &,
      .page-care__scroll.active-1 &
        transform: none;
        transition: all 0.5s 0.5s ease-in-out

      .page-care__scroll.active-2 &
        transform: translate(0, -5%);
        transition: all 0.5s ease-in-out

    @media screen and (max-width: 375px)
      margin-top: 380px;

  &__feature
    width: 230px

    @media screen and (orientation: portrait), (max-width: 768px)
      width: 145px

  &__title
    font-size: 40px
    display: flex
    align-items: center
    margin-bottom: 48px

    @media screen and (max-width: 1440px)
      font-size: 32px
      margin-bottom: 32px

    @media screen and (max-width: 1024px)
      font-size: 24px
      margin-bottom: 26px

    @media screen and (orientation: portrait), (max-width: 768px)
      font-size: 20px
      justify-content: center
      margin-bottom: 12px

    @media screen and (orientation: portrait), (max-width: 375px)
      font-size: 18px
      margin-bottom: 8px

    img
      margin-right: 20px

      @media screen and (orientation: portrait), (max-width: 375px)
        width: 40px
        margin-right: 12px

  &__description
    font-size: 24px
    margin-bottom: 48px

    @media screen and (max-width: 1440px)
      font-size: 18px
      margin-bottom: 32px

    @media screen and (max-width: 1024px)
      font-size: 16px

    @media screen and (orientation: portrait), (max-width: 768px)
      margin-bottom: 24px

    @media screen and (orientation: portrait), (max-width: 375px)
      margin-bottom: 25px
      font-size: 16px

  &__link
    text-decoration: underline
    font-size: 20px

    @media screen and (max-width: 1440px)
      font-size: 14px

</style>
